export default "__VITE_ASSET__s482z3FL__"